import React from 'react';
import { BeastGamesLanding } from './components/BeastGamesLanding';
export function App() {
  return <BeastGamesLanding data-id="element-0" />;
}